export const otto = {
  tokenHelp:
    'Der Token ist zu finden unter "Einstellungen > Store-level API account"',
  oAuthFlowHelp: "Meinen Account autorisieren",
  useSandbox: "{appName} Sandbox aktivieren",
  authSuccess: "Authentifizierung erfolgreich",
  installationTitle: "Installation der Connect Otto Market App",
  installAction: "App installieren",
  errorHandling: {
    ottoInstallationNotFoundTitle:
      "Wir konnten keine Otto-Installation für diese Version finden.",
    ottoInstallationNotFound:
      "<p>Keine Sorge, meist ist die Otto App einfach noch nicht installiert.</p>" +
      "<p>Installiere die Otto App in deinem Otto-Portal über den folgenden Link:</p>" +
      "<a class='btn btn-primary' href='{link}'><strong>Otto App installieren</strong></a><br>" +
      "<p></p>" +
      "<p></p>" +
      "<p></p>" +
      "<p>Sobald die Installation abgeschlossen ist, starte die Einrichtung erneut.</p>"
  }
};
